// @flow
import type { VolopFunctions } from 'api/orgs';
import type { Action } from '../actions/volopFunctions';

export type State = ?VolopFunctions;

export default function volopFunctions(state: State = null, action: Action) {
  switch (action.type) {
    case 'VOLOP_FUNCTIONS_SET': {
      return action.volopFunctions;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
